import { anchorConverter } from './marks/anchor-converter.js';
import { boldConverter } from './marks/bold-converter.js';
import { colorConverter } from './marks/color-converter.js';
import { fontSizeConverter } from './marks/font-size-converter.js';
import { italicConverter } from './marks/italic-converter.js';
import { linkConverter } from './marks/link-converter.js';
import { mentionConverter } from './marks/mention-converter.js';
import { spoilerConverter } from './marks/spoiler-converter.js';
import { underlineConverter } from './marks/underline-converter.js';
import 'ricos-schema';
import 'ricos-types';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getUnsupportedDecorationToTiptap = (decoration) => ({
  types: [decoration.type],
  convert: (decoration2) => {
    const _a = decoration2, { type } = _a, data = __objRest(_a, ["type"]);
    return [
      __spreadProps(__spreadValues({}, data ? { attrs: __spreadValues({}, data) } : {}), {
        type
      })
    ];
  }
});
const getUnsupportedMarkFromTiptap = (mark) => ({
  types: [mark.type],
  convert: ([mark2]) => {
    const _a = mark2, { type, attrs } = _a, data = __objRest(_a, ["type", "attrs"]);
    return __spreadValues(__spreadValues({
      type
    }, data), attrs);
  }
});
const markConverters = [
  anchorConverter,
  boldConverter,
  colorConverter,
  fontSizeConverter,
  italicConverter,
  linkConverter,
  mentionConverter,
  spoilerConverter,
  underlineConverter
];

export { getUnsupportedDecorationToTiptap, getUnsupportedMarkFromTiptap, markConverters };
//# sourceMappingURL=mark-converters.js.map
